/**
 * Domain enums whose values mirror the Postgres enum labels exactly
 * (instructions/05_BACKEND.md). Shared across features.
 */

export const USER_ROLES = ['imam', 'muezzin', 'masjid_admin'] as const;
export type UserRole = (typeof USER_ROLES)[number];

// isProvider MOVED — see `features/profile/model/profile.ts`. It now takes a
// profile with is_imam/is_muezzin flags (D-014), not the legacy role enum.

// 'jumuah' is the Friday khutbah slot (Phase 2, TD-001); it requires a
// khutbah-qualified provider. Kept last so daily-prayer ordering is unchanged.
export const PRAYER_SLOTS = ['fajr', 'dhuhr', 'asr', 'maghrib', 'isha', 'jumuah'] as const;
export type PrayerSlot = (typeof PRAYER_SLOTS)[number];

export const COVERAGE_STATUSES = ['open', 'filled', 'cancelled', 'expired'] as const;
export type CoverageStatus = (typeof COVERAGE_STATUSES)[number];

// How a covering provider is compensated (Phase 8). 'paid_offline' means terms
// are agreed OUTSIDE the app — Badeel processes no payments.
export const COMPENSATION_TYPES = ['volunteer', 'paid_offline'] as const;
export type CompensationType = (typeof COMPENSATION_TYPES)[number];

// 'completed' / 'no_show' added in Phase 3 (the completion lifecycle).
export const APPLICATION_STATUSES = [
  'pending',
  'accepted',
  'rejected',
  'withdrawn',
  'completed',
  'no_show',
] as const;
export type ApplicationStatus = (typeof APPLICATION_STATUSES)[number];

/** 0 = Sunday … 6 = Saturday (Saudi week starts Sunday). */
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6] as const;
export type Weekday = (typeof WEEKDAYS)[number];
